export default __webpack_public_path__ + "static/media/addProduct.507ecea7.png";